export default __webpack_public_path__ + "static/B0037-d10ff9f57f9c3f5ace2e74b85d5bbf74.png";